import './header.scss'
import {connect} from "react-redux";
import {getPropsFromState} from "../../redux/mapStateToProps";
import {ChangeLanguage, GetSearch, GetBlogCount} from "../../redux/actions";
import {
    BurgerMenuIcon, FooterInstagramIcon, InstagramIcon,
    Logo, MobileLogo,
    NewsArrIcon,
    SearchCloseIcon,
    SearchGrayIcon,
    SearchIcon,
    SearchResIcon, TelegramIcon
} from "../../assets/images";
import {Link, NavLink, useHistory, useLocation} from "react-router-dom";
import {Dropdown, Menu} from "antd";
import React, {useEffect, useState} from "react";
import {InputGroup} from "../uiElements/inputGroup/InputGroup";
import {generateFileMediaUrl} from "../../utils/generateMediaUrl";
import moment from "moment";
import {useDebounce} from 'use-debounce';
import Socials from "../socials/Socials";


function Header(props) {
    const {
        staticTexts,
        languages,
        selectedLanguage,
        toggleLanguage,
        toggleMobileMenu,
        search,
        toggleSearchMenu,
        contacts
    } = props
    const [closeLanguage, setCloseLanguage] = useState(false)
    const [mounted, setMounted] = useState(false)
    const [closeSuggestions, setCloseSuggestions] = useState(false)
    const [openSearch, setOpenSearch] = useState(false)
    const [state, setState] = useState('')
    const [value] = useDebounce(state, 1000);
    const history = useHistory()
    const location = useLocation()

    function getInputValues(e) {
        const {value} = e.target
        if (value && !/^\S/.test(value)) {
            return
        }
        setState(value)
    }

    function searchByText() {
        setCloseSuggestions(false)
        history.push({pathname: "/search", state: state});
    }

    useEffect(() => {
        setMounted(true)
        window.addEventListener('click', () => setCloseSuggestions(false));
    }, [])

    useEffect(() => {
        if (mounted) {
            if (value?.length > 2 || value?.length === 0) {
                props.GetBlogCount({text: value})
                props.GetSearch({text: value}).finally(() => {
                    console.log(value)
                    search?.length && setCloseSuggestions(true)
                })
            }
        }

    }, [value])

    useEffect(() => {
        if (location.pathname !== '/search') {
            setState('')
        }
    }, [location.pathname])


    const menuLanguage = (
        <Menu className={`languages-dropdown`}>
            {
                languages?.length && languages?.map((item) => {
                    return selectedLanguage?.code !== item.code &&
                        <Menu.Item key={item.id}
                                   onClick={() => {
                                       props.ChangeLanguage(item)
                                   }}
                                   className={'language-dropdown-item'}>
                            <div className="selected-language">
                                <div className={'language-flag'}>
                                    <img src={generateFileMediaUrl(item?.icon?.path)} alt=""/>
                                </div>
                                <span>{item?.name}</span>
                            </div>
                        </Menu.Item>
                })
            }
        </Menu>
    );


    return <div className={'header-wrapper'}>
        <div className={'header_block'}>
            <div className={'left_menu'}>
                <div className={'burger-menu'} onClick={toggleMobileMenu}>
                    <BurgerMenuIcon/>
                </div>
                <div className={'nav-link'}>
                    <NavLink to={'/about'} activeClassName='active'>
                        <li className="nav-item">{staticTexts?.header_item_about}</li>
                    </NavLink>
                    <NavLink to={'/contact'} activeClassName='active'>
                        <li className="nav-item">{staticTexts?.header_item_contact}</li>
                    </NavLink>
                </div>
                <div className={`search_content ${openSearch ? 'open_search' : ''}`}>
                    {
                        openSearch && <div className={'search_all_wrapper'}>
                            <div className={`search-wrapper ${state ? 'active' : ''}`}>
                                <div className="search-btn" onClick={searchByText}>
                                    <SearchGrayIcon/>
                                </div>
                                <InputGroup inputType={'input'}
                                            type={"text"}
                                            autoFocus={false}
                                            value={state}
                                            name={'text'}
                                            maxLength={100}
                                            onKeyDown={(e) => {
                                                e.key === 'Enter' && searchByText()
                                            }}
                                            placeholder={staticTexts?.header_search_placeholder}
                                            className="search_input"
                                            onChange={getInputValues}>
                                </InputGroup>

                                {
                                    location?.pathname !== "/search" && closeSuggestions ?
                                        <div className={'search-result-wrapper'}>
                                            {
                                                search?.length ? <div className={'search-with-result'}>
                                                    {
                                                        search?.map((item, index) => {
                                                            return <Link to={`/news/${item?.slug}`}
                                                                         className={'search-result-card'} key={index}>
                                                                <div className={'search-result-img-wrapper'}>
                                                                    <div className={'search-result-img'}>
                                                                        <img
                                                                            src={generateFileMediaUrl(item?.mediaMain?.coverPath || item?.mediaMain?.path)}
                                                                            alt=""/>
                                                                    </div>
                                                                </div>
                                                                <div className={'search-result-info'}>
                                                                    <div className={'search-result-date'}>
                                                                        {moment(item?.date).format("MMM Do")}
                                                                    </div>
                                                                    <div className={'search-result-title'}>
                                                                        <span>{item?.title}</span> <NewsArrIcon/>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        })
                                                    }
                                                </div> : <div className={'header-search-notResult'}>
                                                    {staticTexts?.header_search_notResult}
                                                </div>
                                            }
                                        </div> : ''
                                }
                            </div>
                            <div className={'search_close'} onClick={() => {
                                setOpenSearch(false)
                                setState('')
                            }}>
                                <SearchCloseIcon/>
                            </div>
                        </div>
                    }
                    {
                        !openSearch && <div className={'search_close_content'} onClick={() => setOpenSearch(true)}>
                            <SearchIcon/>
                        </div>
                    }
                </div>
            </div>
            <Link to={'/'} className={'header-logo-wrapper'}>
                {
                    window.innerWidth > 1050 ?  <Logo/> :  <MobileLogo/>
                }
            </Link>
            <div className={'right_menu'}>
                {
                    window.innerWidth > 1050 && <div className={'socials_wrapper'}>
                        <Socials contacts={contacts}/>
                    </div>
                }
                <div className={'searchRes-block'} onClick={toggleSearchMenu}>
                    <SearchIcon/>
                </div>
            </div>
        </div>
        {/*<div className={'language-wrapper'}>*/
        }
        {/*    <Dropdown overlay={menuLanguage}*/
        }
        {/*              trigger={['hover']}*/
        }
        {/*              overlayClassName={`${closeLanguage ? "close" : ""}`}*/
        }
        {/*              onClick={() => toggleLanguage(setCloseLanguage(false))}*/
        }
        {/*              placement={'bottomRight'}>*/
        }
        {/*        <a className="ant-dropdown-link">*/
        }
        {/*            <div className="selected-language">*/
        }
        {/*                <div className={'language-flag'}>*/
        }
        {/*                    <img src={generateFileMediaUrl(selectedLanguage?.icon?.path)} alt=""/>*/
        }
        {/*                </div>*/
        }
        {/*                <span>{selectedLanguage?.name}</span>*/
        }
        {/*                <div>*/
        }
        {/*                </div>*/
        }
        {/*            </div>*/
        }
        {/*        </a>*/
        }
        {/*    </Dropdown>*/
        }
        {/*</div>*/
        }
    </div>
}

const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'languages',
        'selectedLanguage',
        'search',
        'contacts',
    ])
};
const mapDispatchToProps = {
    ChangeLanguage,
    GetSearch,
    GetBlogCount,
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);
